import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { duration: Number }
  static targets = ["timer"]

  timeoutId = null
  intervalId = null
  resetHandler = null
  deadline = null

  connect() {
    const duration = this.durationValue ?? 5000
    if (duration === 0) {
      // console.log("Timeout disabled")
      return;
    }

    this.resetHandler = this.resetTimer.bind(this)
    window.addEventListener("click", this.resetHandler)

    this.startTimer(duration)
    // console.log("Timeout connected")
  }

  disconnect() {
    window.removeEventListener("click", this.resetHandler);
    this.clearTimer();
    // console.log("Timeout disconnected");
  }

  startTimer(duration) {
    this.clearTimer()

    this.deadline = Date.now() + duration

    const msLeft = Math.max(0, this.deadline - Date.now())
    this.timeoutId = setTimeout(() => this.logoutUser(), msLeft)

    this.updateTimerDisplay()
    this.intervalId = setInterval(() => {
      this.updateTimerDisplay()
      if (Date.now() >= this.deadline) this.clearTimer()
    }, 1000)
  }

  resetTimer() {
    const duration = this.durationValue ?? 5000
    this.startTimer(duration)
  }

  clearTimer() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
    this.deadline = null
    this.updateTimerDisplay()
  }

  updateTimerDisplay() {
    if (!this.hasTimerTarget) return

    if (!this.deadline) {
      this.timerTarget.textContent = ""
      return
    }

    const ms = Math.max(0, this.deadline - Date.now())
    const minutes = Math.floor(ms / 60000)
    const seconds = Math.floor((ms % 60000) / 1000)
    this.timerTarget.textContent = `${minutes}:${seconds.toString().padStart(2, "0")}`
  }

  logoutUser() {
    this.clearTimer()

    fetch("/users/sign_out", {
      method: "DELETE",
      headers: { "X-CSRF-Token": this.csrfToken() }
    }).then(response => {
      if (response.ok) window.location.href = "/"
      else console.error("Logout failed:", response.status)
    }).catch(err => console.error("Logout error:", err))
  }

  csrfToken() {
    const m = document.querySelector('meta[name="csrf-token"]')
    return m ? m.getAttribute("content") : ""
  }
}